import invariant from 'invariant'
import { isString, isEmpty, isFunction, conformsTo } from 'lodash'
import {
  DAEMON,
  ONCE_TILL_UNMOUNT,
  RESTART_ON_REMOUNT
} from '../constants/configSaga'
import checkStore from './checkStore'

const allowanceMode = [DAEMON, ONCE_TILL_UNMOUNT, RESTART_ON_REMOUNT]

const checkKey = key =>
  invariant(
    isString(key) && !isEmpty(key),
    '(app/src/stores...) injectSaga: expected `key` to be a non empty string'
  )

const checkDescriptor = descriptor => {
  const shape = {
    saga: isFunction,
    mode: mode => isString(mode) && allowanceMode.includes(mode)
  }
  invariant(
    conformsTo(descriptor, shape),
    '(app/src/stores...) injectSaga: expected a valid saga descriptor'
  )
}

export const injectSagaFactory = (store, isValid) => (
  key,
  descriptor = {},
  args
) => {
  if (!isValid) checkStore(store)

  const newDescriptor = {
    ...descriptor,
    mode: descriptor.mode || RESTART_ON_REMOUNT
  }

  const { saga, mode } = newDescriptor

  checkKey(key)
  checkDescriptor(newDescriptor)

  let hasSaga = Reflect.has(store.injectedSaga, key)
  if (process.env.NODE_ENV !== 'production') {
    const oldDescriptor = store.injectedSaga[key]
    if (hasSaga && oldDescriptor.saga !== saga) {
      oldDescriptor.task.cancel()
      hasSaga = false
    }
  }

  if (!hasSaga || (hasSaga && mode !== DAEMON && mode !== ONCE_TILL_UNMOUNT)) {
    store.injectedSaga[key] = {
      ...newDescriptor,
      task: store.runSaga(saga, args)
    }
  }
}

export const ejectSagaFactory = (store, isValid) => key => {
  if (!isValid) checkStore(store)
  checkKey(key)
  if (Reflect.has(store.injectedSaga, key)) {
    const descriptor = store.injectedSaga[key]
    if (descriptor.mode && descriptor.mode !== DAEMON) {
      descriptor.task.cancel()
      if (process.env.NODE_ENV === 'production') {
        store.injectedSaga[key] = 'done'
      }
    }
  }
}

export default store => {
  checkStore(store)

  return {
    injectSaga: injectSagaFactory(store, true),
    ejectSaga: ejectSagaFactory(store, true)
  }
}
